Number.prototype.clamp = function (min, max) {
	return Math.min(Math.max(this, min), max);
};

function getDecimalPlaces(number, decimalPlaces) {
	var toReturn = '';
	if ((number + '').indexOf('.') == -1) {
		return number;
	}
	let splitNumber = (number + '').split('.');
	toReturn = splitNumber[0] + '.';
	let decimals = splitNumber[1];
	for (var i = 0, len = decimals.length; i < len && i < decimalPlaces; i++) {
		toReturn += decimals.charAt(i);
	}
	return parseFloat(toReturn);
}

Number.prototype.decimals = function (decimalPlaces) {
	return getDecimalPlaces(this, decimalPlaces);
};

Object.defineProperty(Number.prototype, 'decimal', {
	get: function decimal() {
		Number.precision = 'precision' in Number ? Number.precision : 3;
		var f = Math.pow(10, Number.precision);
		return Math.round(this * f) / f;
	},
});
